<ion-header class="ion-no-border page menu-page">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/dashboard"></ion-back-button>
    </ion-buttons>
    <ion-title mode="ios">
      <div class="leada-powered">POWERED BY LEADA AG</div>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="goBack()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

</ion-header>

<ion-content class="ion-padding page" no-bounce>
  <div #line class="line" [style.top]="lineY"></div>
  <ion-list lines="none menu">
    <ion-item button disabled><div translate>MENU.KNOWHOW.NAME</div></ion-item>
    <ion-item button (click)="showCModulePage()" *ngIf="hasCModules && showMenuEntry('MENU.KNOWHOW.CMODULES')"><div translate>MENU.KNOWHOW.CMODULES</div></ion-item>
    <ion-item button (click)="showContentsPage()" *ngIf="showMenuEntry('MENU.KNOWHOW.CONTENTS')"><div translate>MENU.KNOWHOW.CONTENTS<ion-badge *ngIf="newContentCount" button-end class="badge">{{ newContentCount }}</ion-badge></div></ion-item>
    <ion-item button (click)="showPodcastPage()" *ngIf="showMenuEntry('MENU.KNOWHOW.PODCASTS')"><div translate>MENU.KNOWHOW.PODCASTS</div></ion-item> 
    <ion-item button (click)="showVideosPage()" *ngIf="showMenuEntry('MENU.KNOWHOW.VIDEOS')"><div translate>MENU.KNOWHOW.VIDEOS</div></ion-item>
    <ion-item button (click)="showTipsPage()" *ngIf="showMenuEntry('MENU.KNOWHOW.TIPS')"><div translate>MENU.KNOWHOW.TIPS</div></ion-item>
</ion-list>

</ion-content>

<ion-footer class="page">
  <ion-button fill="clear" shape="round" (click)="showSettings()" class="settings"><ion-icon slot="icon-only"></ion-icon></ion-button>
  <ion-button fill="clear" shape="round" (click)="showSearch()" class="search"><ion-icon slot="icon-only"></ion-icon></ion-button>
</ion-footer>